<template>
  <div class="login-container">
    <!--    <div class="backgroundImg"></div>-->
    <div class="login-box">
      <div class="box-left">
        <img
          style="width: 480px; height: 500px"
          src="../../assets/login-01.png"
        />
      </div>
      <div class="box-right">
        <div class="title-container">
          <div style="margin-left: 75px">
            <img
              style="width: 43px; height: 41px; vertical-align: bottom"
              src="../../assets/liftIcon.png"
            />
            <span class="title">智慧声纹实时监测系统</span>
          </div>
        </div>

        <el-form
          label-position="left"
          ref="loginForm"
          :model="loginForm"
          inline
          class="login-form"
        >
          <el-form-item label="帐号：" label-width="60px">
            <el-input
              v-model="loginForm.username"
              type="text"
              style="width: 300px"
              placeholder="请输入您的登录帐号"
            />
          </el-form-item>

          <el-form-item label="密码：" label-width="60px">
            <el-input
              v-model="loginForm.password"
              type="password"
              style="width: 300px"
              placeholder="请输入您的帐号密码"
            />
          </el-form-item>

          <el-form-item label="验证码：" label-width="60px">
            <el-input
              v-model="loginForm.code"
              type="text"
              placeholder="请输入验证码"
              style="width: 190px"
            >
            </el-input>
            <img
              @click="getCode()"
              :src="codeUrl"
              height="30px"
              class="code-box"
            />
          </el-form-item>

          <div>
            <el-divider>
              <span
                style="
                  width: 7rem;
                  height: 0.88rem;
                  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                  font-weight: 400;
                  color: #999999;
                  line-height: 0.88rem;
                  font-size: 12px;
                "
                >有问题请联系客服</span
              >
            </el-divider>
          </div>

          <div style="margin-top: 20px; width: 100%; text-align: center">
            <el-button
              class="login-button"
              :loading="loading"
              type="primary"
              @click.native="handleLogin"
              @keyup.enter="keyDown(e)"
            >
              登录
            </el-button>
          </div>
        </el-form>
      </div>
    </div>

    <!-- <div
      style="
        position: absolute;
        top: calc(50% + 300px);
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
      "
    >
      <div class="copyright">
 
        <span
          style="
            width:72px;
            border: 1px solid rgba(68, 215, 182, 1);
            height: 0;
            display: inline-block;
            vertical-align: middle;
          "
        ></span>
        <img
          style="
            width: 0.88rem;
            height: 0.88rem;
            padding: 0.38rem;
            vertical-align: middle;
            display: inline-block;
          "
          src="../../assets/loginlogo.png"
        />
        <span
          style="
            height: 0.88rem;
            font-size: 0.88rem;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #44d7b6;
            display: inline-block;
            line-height: 1.31rem;
          "
          >广州大音智源数字技术有限公司 技术支持</span
        >

        <div
          style="
            width: 72px;
            border: 1px solid rgba(68, 215, 182, 1);
            height: 0;
            margin-left: 0.63rem;
            display: inline-block;
            vertical-align: middle;
          "
        ></div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { sha256 } from "js-sha256";
import { setToken } from "../../utils/auth";

export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        code: "",
        uuid: "",
      },
      loading: false,
      codeUrl: "",
    };
  },
  mounted() {
    this.getCode();
    // 绑定监听事件
    window.addEventListener("keydown", this.keyDown);
  },
  destroyed() {
    // 销毁事件
    window.removeEventListener("keydown", this.keyDown, false);
  },
  methods: {
    keyDown(e) {
      // 回车则执行登录方法 enter键的ASCII是13
      if (e.key == "Enter") {
        this.handleLogin(); // 定义的登录方法
        e.preventDefault(); // 去掉默认的换行
      }
    },

    getCode() {
      this.$api.user.getCode().then((res) => {
        if (res.success) {
          this.codeUrl = res.data.img;
          this.loginForm.uuid = res.data.uuid;
        }
      });
    },

    showcheck() {
      console.log(222);
    },
    async handleLogin() {
      // let password = sha256(this.loginForm.password);
      const params = {
        username: this.loginForm.username,
        password: this.loginForm.password,
        code: this.loginForm.code,
        uuid: this.loginForm.uuid,
      };
      const res = await this.$api.user.login(params);
      console.log(res);

      if (res.success) {
        let _this = this;
        // _this.$store.commit("$_setToken", res.data);
        _this.$store.commit("$_setToken", res.data.id);
        let userInfo = {
          userId: res.data.userId,
          role: res.data.role,
          token: res.data.id,
        };
        window.sessionStorage.setItem("role", res.data.role);
        window.sessionStorage.setItem("username", res.data.username);
        this.$store.state.role = res.data.role;
        this.$store.commit("SET_USER", userInfo);
        setToken(res.data.id);
        // setToken(res.data);
        this.$router.push("/home/site");
        //   if (userInfo.roles[0] === "gambling") {
        //     this.$router.push("script-list").catch((err) => err);
        //   } else if (userInfo.roles[0] === "language") {
        //     this.$router.push("warning-result").catch((err) => err);
        //   } else {
        //   }
        // } else {
      } else {
        // this.$message.warning(res.msg);
        this.$alert(res.msg, "", {
          confirmButtonText: "确定",
          type: "warning",
          center: true,
        }).then((action) => {
          if (action === "confirm") {
            this.getCode();
          }
        });
      }
    },
  },
  computed: {
    loginBtnEnable: function () {
      return (
        this.loginForm.username.length > 0 && this.loginForm.password.length > 0
      );
    },
  },
};
</script>

<style lang="less" scoped>
.login-container {
  height: 100%;
  width: 100%;
  background: url(../../assets/loginbg.png) no-repeat;
  background-size: cover;
  /deep/ .el-form-item {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
}

//.backgroundImg {
//  width: 100%;
//  height: 100%;
//  position: absolute;
//  opacity: 1;
//  z-index: -1;
//  background-size: cover;
//  background-position: center;
//}

.login-box {
  width: 1000px;
  height: 500px;

  //水平垂直居中
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -250px;
  margin-left: -500px;
  //圆角
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;

  display: flex;
  background: #ffffff;
}

.box-left {
  width: 480px;
}

.box-right {
  flex: 1;
  text-align: center;
  width: 100%;
}

.title-container {
  margin-top: 40px;
  display: flex;
  align-items: flex-end;
}

.title {
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: #081118;
  font-size: 24px;
  margin-left: 10px;
}

.login-container .login-form {
  position: relative;
  width: 400px;
  margin: 40px auto 0;
  max-width: 100%;
  overflow: hidden;

  /deep/ .el-color-picker__icon,
  /deep/ .el-form-item__label {
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    padding: 0;
    // line-height: 1rem;
  }
}

.version {
  font-size: 12px;
  margin-left: 10px;
}

.copyright {
  text-align: center;
  color: white;
  align-items: center;
  font-size: 18px;
  .el-divider--horizontal {
    width: 26rem;
  }
}

.login-button {
  width: 300px;
  height: 40px;
  background: #44d7b6;
  border-radius: 23px;

  border: #1f848d;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  color: #ffffff;
  letter-spacing: 0.375rem;
  cursor: pointer;
}

.login-button:hover {
  background: #59fad6 !important;
}

.login-button:active {
  background: #28b192 !important;
}
.login-button:focus {
  background: #28b192 !important;
}

.code-box {
  height: 40px;
  border-radius: 0.25rem;
  border: 0.06rem solid #dcdfe6;
  vertical-align: middle;
  cursor: pointer;
}

.el-divider__text{
  background-color: white !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue